export default {
  data () {
    return {
      /**
       * @description 被编辑行的索引
       */
      editIndex: 0
    }
  },
  methods: {
    /**
     * 自定义行数据
     * @param index 行所在索引
     * @param row 行数据
     * @param templage
     * @param customizeOptions
     */
    handleCustomize (index, row, templage = null, customizeOptions) {

      this.customizeOptions = customizeOptions
      this.isCustomizeDialogShow = true
      this.$emit('dialog-open', {
        mode: 'edit',
        row
      })
      this.editIndex = index
      if (!templage) {
        templage = this.editTemplate
      }
      this.openDialog(index, row, templage)
    }
  }
}
